import $ from 'jquery';
import { disableBodyScroll } from 'body-scroll-lock';
import closeAllMenus from '../../core/INF-closeAllMenus';
import adjustPositioning from './adjustPositioning';

export default function(toggle) {
  // Is the cart already open?
  if ($('[data-state]').hasClass('State--cart-open')) {
    // Are we toggling it closed?
    if (toggle) {
      closeAllMenus();
      return $(document).trigger('scroll');
    }
    return false;
  }

  // Open it up
  $(document).trigger('cartWillOpen');
  closeAllMenus();
  adjustPositioning();
  disableBodyScroll($('[data-cart]')[0]);
  $('[data-state]').addClass('State--cart-open');
  $(document).trigger('scroll');
  return $(document).trigger('cartDidOpen');
}